import { getCdnAssetUrl } from '@/assets';

const preloaded = new Set();

/**
 * Preload images so they're cached before the user needs them.
 * @param {string[]} paths - Paths relative to images/assets/ on CDN
 * @param {{ strategy?: 'link' | 'image' | 'fetch' }} options
 *   - 'link': <link rel="preload"> — high priority, for above-the-fold images
 *   - 'image': new Image() — background download, for upcoming screens
 *   - 'fetch': <link rel="preload" as="fetch"> — for JSON/non-image assets
 */
export function preloadImages(paths, { strategy = 'image' } = {}) {
  if (typeof document === 'undefined') return;

  paths.forEach((path) => {
    if (preloaded.has(path)) return;
    preloaded.add(path);

    const url = getCdnAssetUrl(path);
    if (strategy === 'link' || strategy === 'fetch') {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = strategy === 'fetch' ? 'fetch' : 'image';
      link.href = url;
      if (strategy === 'fetch') link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    } else {
      new Image().src = url;
    }
  });
}
